<template>
  <div class="Nav">
    <div
      class="navContainer"
      :class="containerClasses"
      ref="container"
    >
      <div
        class="NavList"
        v-for="(item, index) in items"
        :key="index"
        ref="tab"
        ref-in-for
        @click="handleClick(index)"
      >
        <div class="navText" :class="{ active: activeIndex === index }">
          {{ item }}
        </div>
      </div>
      <div class="navBottomLineSlider" :style="lineStyle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavTabs",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lineStyle: {
        width: "40px",
        transform: "translateX(0px)",
      },
    };
  },
  computed: {
    containerClasses() {
      return {
        "navContainer--even": this.items.length < 4,
      };
    },
  },
  watch: {
    activeIndex: {
      immediate: true,
      handler() {
        this.syncNavState();
      },
    },
    items: {
      handler() {
        this.syncNavState();
      },
      deep: true,
    },
  },
  mounted() {
    this.syncNavState();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleClick(index) {
      this.$emit("change", index);
    },
    handleResize() {
      this.syncNavState();
    },
    syncNavState() {
      this.$nextTick(() => {
        this.updateIndicator();
        this.scrollActiveIntoView();
      });
    },
    updateIndicator() {
      const tabs = this.$refs.tab || [];
      const activeTab = tabs[this.activeIndex];
      const container = this.$refs.container;
      if (!activeTab || !container) {
        return;
      }
      const textEl = activeTab.querySelector(".navText") || activeTab;
      const containerRect = container.getBoundingClientRect();
      const textRect = textEl.getBoundingClientRect();
      // 固定宽度 40px，始终居中到当前 tab 文本中心
      const indicatorWidth = 40;
      // 需要加上 container.scrollLeft，否则在横向滚动后位置会偏左
      const textCenter =
        container.scrollLeft +
        (textRect.left - containerRect.left + textRect.width / 2);
      const left = textCenter - indicatorWidth / 2;
      this.lineStyle = {
        width: `${indicatorWidth}px`,
        transform: `translateX(${left}px)`,
      };
    },
    scrollActiveIntoView() {
      const tabs = this.$refs.tab || [];
      const activeTab = tabs[this.activeIndex];
      const container = this.$refs.container;
      if (!activeTab || !container) {
        return;
      }
      const target =
        activeTab.offsetLeft +
        activeTab.offsetWidth / 2 -
        container.clientWidth / 2;
      const maxScroll = container.scrollWidth - container.clientWidth;
      const nextScroll = Math.min(Math.max(target, 0), Math.max(maxScroll, 0));
      if (typeof container.scrollTo === "function") {
        container.scrollTo({
          left: nextScroll,
          behavior: "smooth",
        });
      } else {
        container.scrollLeft = nextScroll;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "NavTabs";

.navContainer {
  position: relative;
}

.navBottomLineSlider {
  position: absolute;
  bottom: 0;
  left: 0;
  height: pr(2);
  background: var(--blue, #0093ff);
  transition: transform 0.3s ease, width 0.3s ease;
  will-change: transform, width;
}
</style>

